/**
 * @generated SignedSource<<7300833521a41bd648c50db842f3a2df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_buyer$data = {
  readonly hasAnyTradeStatus: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_buyer" | "CheckoutSidebarProjectPane_buyer" | "CheckoutTaxExemption_buyer" | "CheckoutTotals_buyer" | "useCustomsMessagingQuery_buyer">;
  readonly " $fragmentType": "CheckoutSidebar_buyer";
};
export type CheckoutSidebar_buyer$key = {
  readonly " $data"?: CheckoutSidebar_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_buyer",
  "selections": [
    {
      "alias": "hasAnyTradeStatus",
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarItemInfo_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemption_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarProjectPane_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomsMessagingQuery_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7c34110d6ef67588f500554d78b05ef3";

export default node;
